import React from "react";
import { motion } from "framer-motion";
import { Section } from "./Section";
import { testimonials } from "../../data/portfolio";

export const Testimonials = () => {
  return (
    <Section
      id="testimonials"
      label="Proof"
      title="Kata mereka yang pernah bekerja bersama saya."
      index={2}
    >
      <div className="grid grid-cols-1 md:grid-cols-2 gap-px bg-neutral-900">
        {testimonials.map((t, i) => (
          <motion.div
            key={t.name + i}
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true, margin: "-80px" }}
            transition={{ duration: 0.7, ease: [0.16, 1, 0.3, 1], delay: i * 0.1 }}
            className="relative bg-[#0a0a0a] p-8 md:p-10 flex flex-col gap-8 group hover:bg-[#111] transition-colors duration-500"
            data-testid={`testimonial-card-${i}`}
          >
            {/* Project tag */}
            {t.project && (
              <span className="font-mono text-[10px] uppercase tracking-[0.2em] text-neutral-600 border border-neutral-800 px-2 py-1 self-start">
                {t.project}
              </span>
            )}

            {/* Quote mark */}
            <span
              aria-hidden
              className="absolute top-8 right-8 font-serif text-7xl leading-none text-neutral-800 select-none group-hover:text-neutral-700 transition-colors duration-500"
            >
              "
            </span>

            {/* Quote body */}
            <blockquote className="font-serif text-lg md:text-xl leading-relaxed text-neutral-200 italic relative z-10 flex-1">
              "{t.quote}"
            </blockquote>

            {/* Divider */}
            <div className="border-t border-neutral-900" />

            {/* Author */}
            <div className="flex items-center gap-4">
              <img
                src={t.avatar}
                alt={t.name}
                className="w-10 h-10 rounded-full grayscale contrast-125"
                loading="lazy"
              />
              <div>
                <div className="font-mono text-sm text-neutral-100">{t.name}</div>
                <div className="font-mono text-xs text-neutral-500 mt-0.5">
                  {t.role}
                  {t.org ? ` · ${t.org}` : ""}
                </div>
              </div>
            </div>
          </motion.div>
        ))}
      </div>
    </Section>
  );
};

export default Testimonials;